export const OVERVIEW_UPDATE_STATE = 'fulcrum/containers/NotebookCpu/OVERVIEW_UPDATE_STATE'
export const OVERVIEW_ADD_MEMORY = 'fulcrum/containers/NotebookCpu/OVERVIEW_ADD_MEMORY'
export const OVERVIEW_REFRESH_MEMORY = 'fulcrum/containers/NotebookCpu/OVERVIEW_REFRESH_MEMORY'
export const UPDATE_STATE_ENTIRE_OBJ = 'fulcrum/containers/NotebookCpu/UPDATE_STATE_ENTIRE_OBJ'
export const OPEN_MEMORY_BROWSER_WITH_FILTER = 'fulcrum/containers/NotebookCpu/OPEN_MEMORY_BROWSER_WITH_FILTER'

export const TOGGLE_POPUP = 'fulcrum/containers/NotebookCpu/TOGGLE_POPUP'
export const TOGGLE_FILTER = 'fulcrum/containers/NotebookCpu/UPDATE_FILTER'
export const UPDATE_CONFIG_SELECTION = 'fulcrum/containers/NotebookCpu/UPDATE_CONFIG_SELECTION'
export const UPDATE_CONFIG_SOURCE = 'fulcrum/containers/NotebookCpu/UPDATE_CONFIG_SOURCE'
export const INITIALIZE_FILTER = 'fulcrum/containers/NotebookCpu/INITIALIZE_FILTER'
export const ADD_CONFIG = 'fulcrum/containers/NotebookCpu/ADD_CONFIG'
export const UPDATE_CONFIG_MODEL_NAME = 'fulcrum/containers/NotebookCpu/UPDATE_CONFIG_MODEL_NAME'
export const DELETE_PART = 'fulcrum/containers/NotebookCpu/DELETE_PART'
export const REFRESH_FILTER = 'fulcrum/containers/NotebookCpu/REFRESH_FILTER'

export const ARCH = 'fulcrum/containers/NotebookCpu/ARCH'
export const BRAND = 'fulcrum/containers/NotebookCpu/BRAND'
export const CLASSIFICATION = 'fulcrum/containers/NotebookCpu/CLASSIFICATION'
export const UPDATE_CURRENT_CONFIG = 'fulcrum/containers/NotebookCpu/UPDATE_CURRENT_CONFIG'
